<template>
    <Navbar/>
    <div class="blog-details-area ptb-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="blog-details-desc">
                        <div class="article-image">
                           
                            <router-link to="/blog-grid" class="tag">Brandin</router-link>
                            <img :src= "`https://content.meander.software/${successData[0]?.attributes?.image?.data?.attributes?.url}`" alt="blog-details">
                        </div>
                        <div class="article-content">
                            <div class="entry-meta">
                                <ul>
                                    <li><i class="ri-calendar-2-line"></i>March 14, 2021</li>

                                </ul>
                            </div>
                            <h4>{{successData[0]?.attributes?.title || "Branding involves developing strategy to create a pin point of differentiation the marketing"}}</h4>
                            <p  v-html="renderedMarkdown" >
                                
                            </p>
       
                        </div>
                       
                        <div class="related-post">
                            <h3 class="title">Related Post</h3>
                            <div class="row justify-content-center">
                                <div class="col-lg-6 col-md-6" v-for="feature in filteredSuccessData?.slice(0, 2)" :key="feature?.id">
                                    <div class="single-blog-post">
                                        <div class="image">
                                            <router-link to="/success-stories"

                                             class="d-block"
                                             >
                                                <img :src= "`https://content.meander.software/${feature.attributes?.image?.data?.attributes?.url}`" alt="blog-details">
                                            </router-link>
                                            <router-link to="/blog-grid" class="tag">Branding</router-link>
                                        </div>
                                        <div class="content">
                                            <ul class="meta">
                                                <li><i class="ri-time-line"></i> April 14, 2021</li>
                                                <li><i class="ri-message-2-line"></i> <router-link to="/">(0) Comment</router-link></li>
                                            </ul>
                                            <h3><router-link :to="`/success-stories/${feature?.attributes?.slug}`">{{feature?.attributes?.title   }}</router-link></h3>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <aside class="widget-area">

                        <div class="widget widget_meander_software_posts_thumb">
                            <h3 class="widget-title">Popular Posts</h3>
                            <article class="item">
                                <router-link to="/" class="thumb"><span class="fullimage cover bg1" role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link to="/">Being The Best-Selling Smart Phone This Year</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i> Jan 15, 2020</span>
                                </div>
                            </article>
                            <article class="item">
                                <router-link to="/" class="thumb"><span class="fullimage cover bg2" role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link to="/">Love Songs Helped Me Through Heartbreak</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i> Jan 14, 2020</span>
                                </div>
                            </article>
                            <article class="item">
                                <router-link to="/" class="thumb"><span class="fullimage cover bg3" role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link to="/">Two Fashion Designers Busy With 2020 Winter Fashion</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i> Jan 13, 2020</span>
                                </div>
                            </article>
                            <article class="item">
                                <router-link to="/" class="thumb"><span class="fullimage cover bg4" role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link to="/">Working in the Office is a Tradition For Women</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i> Jan 12, 2020</span>
                                </div>
                            </article>
                        </div>

            


                    </aside>
                </div>
            </div>
        </div>
    </div>
    <FooterStyleFour/>
</template>

<script>
import Navbar from '../../Layout/Navbar'
import FooterStyleFour from '../../Layout/FooterStyleFour'
import axios from 'axios';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt()
export default {
    name: 'SuccessDetailPage',
    components: {
        Navbar,
        FooterStyleFour,
    },
    data: () => ({
  
        
        baseUrl: 'https://content.meander.software',
        contentData:'',
        markdownContent: '# Hello, Markdown!',
      successData:[],
      allsuccessData:[],
      isLoading: false,
    }),
  
    async mounted() {
    await this.getData();
    await this.getDataall()

  },
    methods:{
        async getData() {
      const slug = this.$route.params.slug;
      
      try {
        const response = await axios.get(`${this.$baseUrl}/ms-succes-stories?filters[slug][$eq]=${slug}&populate=*`);
        const { data } = response
        this.successData = data.data;
        this.contentData = this.successData[0]?.attributes?.content
      

      } catch (error) {
        console.error(error)
      }
    },


    async getDataall() {
     
     try {
       const response = await axios.get(`${this.$baseUrl}/ms-succes-stories?&populate=*`
       );
       const { data  } = response;
       this.allsuccessData = data.data;
        
     } catch (error) {
        console.warn(error);
     }
   },
   async changeData(data) {
     
      const routeObject = { name: 'success-stories', params: { slug: data } };
      
      await this.$router.push(routeObject);
      this.getData()
    },
  
    },
    computed: {
  filteredSuccessData() {
    const filterSlug = this.$route.params.slug; // Replace with the actual slug to filter
    return this.allsuccessData?.filter(feature => feature.attributes?.slug !== filterSlug) || [];
  },
  renderedMarkdown() {
      return md.render(this.contentData);
    },
}
}
</script>